import {
    Alert 
} from 'antd';
import { useState } from "react";
import { useTranslation } from "react-i18next";
import '../image/VehicleTyreDiagram.css';
import EditTyre from '../../sections/tyre_request/EditTyre';


const VehicleTyreDiagram = ({vehicle, vehicleId, currentTyreRequest, notification, axleDetails, setAxleDetails, popupCentre, diagramHeight, positionsLoaded, windowWidth,
                             vehicleHasTyres}) => {
    const { t } = useTranslation();
    const [isEditTyreModalVisible, setIsEditTyreModalVisible] = useState(false); 
    const [popupTyre, setPopupTyre] = useState(null);   //by putting state on the popupTyre, it ensures the re-populating of the tyre edit modal is correct

    notification.destroy();


    const editTyreRequest = (tyre, currentTyreRequest) => {
        // when the work request is submitted to the back office, the currentTyreRequest object is initialised along with popupAncillary being removed from the object itself
        // hence included below check
        // if (!currentTyreRequest.hasOwnProperty('popupTyre')){
            // currentTyreRequest.popupTyre = {};
        // }
        // currentTyreRequest.popupTyre=null;
        // currentTyreRequest.popupTyre=tyre;
        setPopupTyre(tyre); //This code ensures the re-populating of the tyre edit modal is correct with already captured details
        setIsEditTyreModalVisible(true);
    }

    const getColour = (tyreCode) => {
        let hasTyreRequest = currentTyreRequest?.tyres?.find(tyre => tyre.tyreId === tyreCode);
        return hasTyreRequest ? 'var(--dp-status-colour-ok)' : '#d6d4d4';
    }

    const VehicleTyres = ({currentTyreRequest}) => {

        return (
            <div>
                {
                axleDetails.axles.map(axle => {
                    return (
                        <div>
                           
                            <div className='axle-base' style={{left: axle.leftPos, top: axle.topPos}}></div>
                            {
                                axle.rightTyres.map(rightTyre => {
                                    return (
                                        <div className='axle-tyre'
                                             style={{left: rightTyre.leftPos, top: rightTyre.topPos, backgroundColor: getColour(rightTyre.id)}}
                                             onClick={() => {
                                                editTyreRequest(rightTyre, currentTyreRequest);
                                            }}
                                        > 
                                        </div>
                                    )
                                }
                                )
                            } 
                            {
                                axle.leftTyres.map(leftTyre => {
                                    return (
                                       <div className="axle-tyre"
                                            style={{left: leftTyre.leftPos, top: leftTyre.topPos, backgroundColor: getColour(leftTyre.id)}}
                                            onClick={() => {
                                                editTyreRequest(leftTyre, currentTyreRequest);
                                            }}
                                       >

                                       </div>
                                    )
                                })
                            }
                        </div>
                    );
                })
                }
                {
                    axleDetails.spareTyres.map(spareTyre => {
                        return (
                            <div className='spare-tyre'
                                 style={{top: spareTyre.topPos, left: spareTyre.leftPos, backgroundColor: getColour(spareTyre.id)}}
                                 onClick={() => {
                                    editTyreRequest(spareTyre, currentTyreRequest);
                                }}
                            > 
                            </div>
                        )
                    })
                }

                <div className='main-axle' style={{height: axleDetails.baseAxleHeight  + 'px', left: '' + (popupCentre - 5) + 'px'}}></div>
                <div className='front-arrow' style={{left: '' + (popupCentre - 50) + 'px'}}></div>
            </div>
        );
    }
    
    return (
        <div style={{height: diagramHeight + 30 +'px'}}>
            {
                !vehicleHasTyres
                ?
                <Alert showIcon message={t('message.no_tyres_configured')}  type="warning" />
                :
                axleDetails && axleDetails.axles && axleDetails.axles.length > 0 && positionsLoaded
                ?
                <div>
                    <Alert showIcon message={t('message.tyre_advisory')} type="info" />
                    <VehicleTyres currentTyreRequest={currentTyreRequest}/>
                    <EditTyre isEditTyreModalVisible={isEditTyreModalVisible}
                              setIsEditTyreModalVisible={setIsEditTyreModalVisible}
                              currentTyreRequest={currentTyreRequest}
                              vehicle={vehicle}
                              popupTyre={popupTyre}
                              setPopupTyre={setPopupTyre}
                    > 
                    </EditTyre>                
                </div>
                :
                <></>
            
            }
        </div>
    );
}

export default VehicleTyreDiagram;